export default {
      id: "arrow-right-circle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#arrow-right-circle",
      toString: function () {
        return this.url;
      }
    }